var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.691 26.679H7.146a6.545 6.545 0 01-6.544-6.545V7.044A6.545 6.545 0 017.146.5h13.09a6.545 6.545 0 016.544 6.545v13.09a6.545 6.545 0 01-6.544 6.544H17.78a2.045 2.045 0 10-4.09 0z",
    fill: "#3764B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.873 7.863h7.363a3.682 3.682 0 00.376-7.344C20.487.512 20.362.5 20.236.5H7.146A6.545 6.545 0 00.602 7.045v13.09a12.272 12.272 0 0112.27-12.272z",
    fill: "#507DD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.236 13.59a6.544 6.544 0 106.544 6.544V7.044a6.545 6.545 0 01-6.544 6.545z",
    fill: "#1E4BA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.872 7.863a.818.818 0 01-.818.818H18.6a.818.818 0 00-.818.818v3.272h3.092a.818.818 0 01.802.979l-.49 2.454a.818.818 0 01-.803.658h-2.601v9.817h-4.09v-9.817h-2.455a.818.818 0 01-.818-.818v-2.455a.818.818 0 01.818-.818h2.454V9.5A4.909 4.909 0 0118.6 4.59h2.454a.818.818 0 01.818.818v2.455z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/facebook.4ddfa460e84e87ee5b8414f987937f5e.svg";
export { SvgFacebook as ReactComponent };